import { type JobsApi } from '@/features/jobs/api/job-api'
import { Id } from '@/infra/id'

/**
 * Fetches SurePrep files for jobs.
 */
export class SureprepStore {
  constructor(private readonly _api: JobsApi) {}

  /**
   * Fetches the job's SurePrep binder (PBFX) file.
   *
   * @param jobId
   */
  async fetchBinder(jobId: Id): Promise<Blob> {
    const data = await this._api.sureprep.downloadPBFXFile(Id.assert(jobId))
    return new Blob([data], { type: 'application/octet-stream' })
  }
}
